import chatInputStore from '@/components/chat/ChatInput/store';
import { SVGPureIcon } from '@/ui';
import Arrow from './Arrow';
const PromptExample = ({ data }) => {

  if(!data?.length) return null;

  return (
    <div className="w-800px mx-auto h-full mb-16px">
      <div className='h-48px pointer-events-none' ></div>
      <div className="text-14px text-black text-opacity-50 font-bold-500 bg-white ">
        试着对我说:
      </div>
      
      <div className="flex gap-7px mt-14px">
        {data.slice(0, 3).map((item, index) => (
          <div
            key={index}
            className="prompt-example relative w-[33.3%] flex items-center  px-21px py-12px border-1 border-black border-opacity-16 rounded-12px rounded-bl-none "
            onClick={() => {
              chatInputStore.setContent(item);
            }}
          >
            <Arrow />
            <p
              className="w-full mb-0 line-clamp-2 max-h-40px leading-20px text-14px text-black cursor-pointer"
              style={{
                wordBreak: 'break-all',
              }}
              title={item}
            >
              {item}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PromptExample;
